import React from "react";

const Footer = () => {
    return (
        <div className="bg-dark container-fluid p-4 text-center">
            <span className="text-light">
                Copyright Mawe Shop - 2023. Todos los derechos reservados. Defensa de las y los consumidores. Para
                reclamos <a href="https://autogestion.produccion.gob.ar/consumidores">ingrese aquí</a>
            </span>
        </div>
    );
};

export default Footer;
